import { render, staticRenderFns } from "./TransformingDataExcel.vue?vue&type=template&id=1d506d56&scoped=true"
import script from "./TransformingDataExcel.vue?vue&type=script&lang=js"
export * from "./TransformingDataExcel.vue?vue&type=script&lang=js"
import style0 from "./TransformingDataExcel.vue?vue&type=style&index=0&id=1d506d56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d506d56",
  null
  
)

export default component.exports